import { render, staticRenderFns } from "./DetailAnnouncementResearchProfessor.html?vue&type=template&id=3831e870&scoped=true&external"
import script from "./DetailAnnouncementResearchProfessor.vue?vue&type=script&lang=js"
export * from "./DetailAnnouncementResearchProfessor.vue?vue&type=script&lang=js"
import style0 from "./DetailAnnouncementResearchProfessor.scss?vue&type=style&index=0&id=3831e870&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831e870",
  null
  
)

export default component.exports